import React, { useState, useEffect, useRef } from "react";
import { Link } from "react-router-dom";
import projectvideo from "C:/Users/yrsha/client1/src/assets/projectvideo.mp4";
import placeholderImage from "C:/Users/yrsha/client1/src/assets/placeholderImage.jpg";
import Choose from "C:/Users/yrsha/client1/src/assets/chooseus.jpg";
import service1 from "C:/Users/yrsha/client1/src/assets/service1.jpg"; 
import service2 from "C:/Users/yrsha/client1/src/assets/service2.jpg"; 
import service3 from "C:/Users/yrsha/client1/src/assets/service3.jpg"; 
import service4 from "C:/Users/yrsha/client1/src/assets/service4.jpg"; 
import service5 from "C:/Users/yrsha/client1/src/assets/service5.jpg";
import service6 from "C:/Users/yrsha/client1/src/assets/service6.jpg";
import service7 from "C:/Users/yrsha/client1/src/assets/service7.jpg"; 
import "C:/Users/yrsha/client1/src/App.css";

const servicesImages = [service1, service2, service3, service4, service5, service6, service7];

const Home = () => {
  
  // Initialize videoError state
  const [videoError, setVideoError] = useState(false);

  // State for slideshow
  const [currentImage, setCurrentImage] = useState(0);
  
  // Refs for sections to animate
  const featuresRef = useRef(null);
  const servicesRef = useRef(null);
  const contactRef = useRef(null);

  // Intersection Observer to trigger animations
  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            console.log(`${entry.target.className} is visible`);
            entry.target.classList.add("visible");
          }
        });
      },
      {
        threshold: 0.5, // Trigger when 50% of the element is visible
      }
    );

    if (featuresRef.current) observer.observe(featuresRef.current);
    if (servicesRef.current) observer.observe(servicesRef.current);
    if (contactRef.current) observer.observe(contactRef.current);

    // Cleanup observer on unmount
    return () => {
      if (featuresRef.current) observer.unobserve(featuresRef.current);
      if (servicesRef.current) observer.unobserve(servicesRef.current);
      if (contactRef.current) observer.unobserve(contactRef.current);
    };
  }, []);

  
  

  // Auto-slide effect every 3 seconds
  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentImage((prevIndex) => (prevIndex + 1) % servicesImages.length);
    }, 3500);
    return () => clearInterval(interval);
  }, []);

  return (
    <div className="home-page">
      {/* Hero Section with Video Background */}
      <section id="hero-section" className="hero-section" loading="lazy">
        <video 
        className="video-background" 
        autoPlay 
        muted 
        loop 
        onError={() => {
          setVideoError(true); }}
        >
          <source src={projectvideo} type="video/mp4" />
          Your browser does not support the video tag.
        </video>
        <div className="hero-content">
          <h1 className="welcome-heading">Welcome to <br></br> <strong>TAAS </strong> Services</h1>
          <p>Delivering Excellence and Innovation</p>
          <Link to="/About" className="btn btn-primary">
          Learn More
          </Link>
        </div>
        {/* Placeholder image */}
        {videoError && (
          <img
            src={placeholderImage}
            alt="Placeholder image"
            className="video-placeholder"
          />
        )}
      </section>

      {/* Features Section */}
      <section ref={featuresRef} className="features-section">
        <div className="features-container">
          {/* Image Placeholder */}
          <div className="features-image">
            <img src={Choose} alt="Features Placeholder" loading="lazy"/>
            </div>
            
            {/* Text Content */}
            <div className="features-text">
              <h2><strong>Why Choose Us?</strong></h2>
              <ul>
              We provide innovative, result-oriented engineering solutions with a commitment to quality, reliability, and efficiency. Backed by over 3 decade of expertise, we ensure long-lasting technical support tailored to your industry needs.
              </ul>
            </div>
          </div>
        </section>


      {/* Services Preview Section (Text Left, Slideshow Right) */}
      <section ref={servicesRef} className="services-preview">
        <div className="service-container">
          {/* Text Content */}
          <div className="services-text">
            <h2>Our Services</h2>
            <p>Explore the wide range of services we offer:</p>
            <ul>
            We specialize in comprehensive motor rewinding, electrical repairs, and technical maintenance for industries like power rental, oil & gas, construction, and marine engineering. Our expert solutions ensure efficiency, durability, and peak performance.
            </ul>
            <Link to="/services" className="btn btn-secondary">View All Services</Link>
          </div>

          {/* Slideshow */}
          <div className="slideshow-container">
            <button 
              className="prev" 
              onClick={() => setCurrentImage((prev) => (prev - 1 + servicesImages.length) % servicesImages.length)}
            >
              &#10094;
            </button>
            
            <img 
              src={servicesImages[currentImage]} 
              alt="Service" 
              className="slideshow-image" 
            />
            
            <button 
              className="next" 
              onClick={() => setCurrentImage((prev) => (prev + 1) % servicesImages.length)}
            >
              &#10095;
            </button>
          </div>
        </div>
      </section>
    

      {/* Contact Call-to-Action */}
      <section ref={contactRef} className="contact-cta">
        <h2>Get in Touch</h2>
        <p>Have questions? Need assistance? 
        <ul> Contact us today! </ul>
        </p>
        <Link to="/contact" className="btn btn-success">
          Contact Us
        </Link>
      </section>
    </div>
  );
};

export default Home;
